var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002 1.25195C15.5246 1.25214 20.002 5.16957 20.002 10.002C20.0017 14.8341 15.5244 18.7518 10.002 18.752C8.98101 18.752 7.99518 18.6179 7.06738 18.3691C6.3274 18.7441 4.61467 19.4688 1.72461 19.9297C1.52552 19.9614 1.37263 19.7541 1.45312 19.5693C1.91424 18.5128 2.33792 17.0669 2.46387 15.752C0.930571 14.2143 0.00208482 12.2029 0.00195312 10.002C0.00195312 5.16946 4.47911 1.25195 10.002 1.25195Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkAnswer);
export default __webpack_public_path__ + "static/media/nav-link-answer.cbf001c7e8164940e52f79cfdc3d0bd9.svg";
export { ForwardRef as ReactComponent };